import React, { useState } from "react";
import axios from "axios";
const jwt = localStorage.getItem('jwt');


var urlParams = new URLSearchParams(window.location.search);
console.log(urlParams);
var resetToken = urlParams.get('code');
console.log(resetToken);

  
const ConfirmPassword = () => {
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [message, setMessage] = useState('');	
	
	if(!resetToken)
	{
		console.error('No reset token found in URL!');
		//alert("No reset token found!");
		window.location.href = '/login';
	}

  

    const handleSubmit = async (event) => {
    event.preventDefault();
    
    if(password !== confirmPassword)
	{
		console.log('Password do not match');
		setMessage("Password do not match.");
		return;
	}
    
    try {
      const response = await axios.post(
        'https://testwire.wockhardt.com/api/auth/reset-password',
        {
          code: resetToken,
          password: password,
          passwordConfirmation: confirmPassword
        }
      );
      //console.log(response.data);
      if(response.status === 200)
	{
		alert('Password reset successfully!');
		window.location.href = '/login';
	}
	else{
		setMessage(response.error.message);
		return;
	}
    } catch (error) {
    	//setMessage(response.error.message);
    	setMessage(error.response.data.error.message);
    	//alert("An error occurred. Please try again later.");
      
      console.error(error);
    }
  };

  return (
    <div className='bg-silver1'>
      {/*<div className='bg-white fixed top-0 right-0 left-0 z-20'>
        <div className="flex justify-between mb-2" > 
          <div className='mt-3 ml-5'>
            <a href='/'><img src="/Other_Images/e2logo.png" class="img-fluid w-[183px] h-[45px]" alt=""></img></a>
          </div>
        </div>
  </div>*/} 
      <section>     
      <div className="bg-silver1">
        <div className='lg:flex justify-around pt-8 mx-4'>
          <div className='bg-white rounded-2xl p-4 my-4 lg:my-0 ' style={{ background:'#fff', position:"relative", paddingTop:30, paddingBottom:30, paddingLeft:60, paddingRight:60, fontSize:16, fontWeight:400 }}>
            <div className='lg:flex'>
              <div className='lg:w-[50%]'>
                {/*<img src="/Other_Images/e2logo.png" class="img-fluid w-[183px] h-[45px]" alt=""></img>*/}
                <img src="/Other_Images/coverPic.png" class="img-fluid" alt=""></img>
              </div>
              <div className='lg:w-[50%]' style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                <img src="/Other_Images/e2logo.png" class="img-fluid w-[183px] h-[45px]" style={{marginBottom:10}} alt=""></img>
                <h3 style={{fontWeight:'700', fontSize:'1.625rem', marginBottom:'0.25rem !important'}}>Welcome to E2-Portal! 👋</h3>
                <p className="mb-4" style={{marginBottom:'0.25rem !important;'}}>Enter your new Password for Login!</p>
                {message && <p class="error-message error" style={{ color:'white', backgroundColor:'lightcoral', padding:'10px'}}><b>{message}</b></p>}
                <form className="mt-4" id="reset-password-form" action="/api/auth/reset-password" method="POST" onSubmit={handleSubmit}>
                  <div className="form-group text-xs" style={{ marginTop:'5%', fontWeight:400 }}>
                    <label for="exampleInputEmail1" style={{ display:"inline-block", marginBottom:8,fontSize: '0.8125rem',color: '#5d596c' }}>Enter New Password</label>
                  </div>
                  <input className="text-xs" style={{ width:'100%', lineHeight:'1.5', background:'#ffffff',border: '1px solid #dbdade',borderRadius: '0.375rem', padding: '0.422rem 0.875rem',fontSize:'0.9375rem', marginBottom:0, fontWeight:400, }} type="password" class="form-control" id="password" name="password" placeholder="Enter new password" required value={password} onChange={(event) => setPassword(event.target.value)}/>
                  <label for="exampleInputEmail1" style={{ display:"inline-block", marginBottom:8,fontSize: '0.8125rem',color: '#5d596c' }}>Confirm Your Password</label>
                  <input className="text-xs" style={{ width:'100%', lineHeight:'1.5', background:'#ffffff',border: '1px solid #dbdade',borderRadius: '0.375rem', padding: '0.422rem 0.875rem',fontSize:'0.9375rem', marginBottom:0, fontWeight:400, }} type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm your password" required value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)}/>
                  <input type="hidden" name="code" id="reset-token" />
                  <div class="d-inline-block w-100 text-sm">
                    <button className="text-xs" style={{ marginTop:'5%', padding:10, color:'#fd6047', width:'100%', color:'#fff', backgroundColor:'#2f75b6', borderColor:'#2f75b6' }} type="submit" class="btn btn-primary">Update Password</button>
                  </div> 
                  <p class="text-center" style={{ marginTop:10, padding:10, color:'#2f75b6' }}><a type="submit" class="btn btn-primary center" href="/login"><span>Back to Login</span></a></p>                   
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      </section> 
    </div>
  );
};

export default ConfirmPassword;
